module.exports = __webpack_public_path__ + "img/checkmark.e90b7b43.svg";